import {useEffect, useState} from "react";

type MortgageKey = keyof typeof mortgageData;

const mortgageData = {
    'Семейная': {
        rate: 6,
        downPayment: 20.1,
        maxLoan: 30000000,
        description: (
            <>
                <p className="plan-calc-info-desc">
                Льготную «Семейную ипотеку» со сниженной процентной ставкой до 6% годовых могут получить:<br />
                - семьи с детьми, где есть хотя бы один ребенок в возрасте до 7 лет на момент подписания кредитного договора;<br />
                - семьи, проживающие в малых городах с населением до 50 тыс. человек и имеющие двух несовершеннолетних детей (от 7 до 18 лет);<br />
                - семьи, где есть ребенок-инвалид в возрасте до 18 лет.<br />
                Граждане, которые не подходят под указанные требования, могут воспользоваться «Донорской ипотекой», позволяющей привлечь в качестве созаемщиков «доноров» — близких родственников, друзей, знакомых, коллег по работе, которые имеют право на семейную ипотеку.  
                </p>
            </>
        ),
    },
    'Военная ипотека': {
        rate: 6,
        downPayment: 20,
        maxLoan: 4740000,
        description: (
            <>
                <p className="plan-calc-info-desc">
                Военная ипотека – это целевой жилищный заем, предназначенный для военнослужащих, участвующих в накопительно-ипотечной системе (НИС).<br />
                Чтобы получить ипотеку на льготных условиях, военные должны служить по контракту и участвовать в НИС не менее чем три года (если кандидат является участником боевых действий, то кредитный договор можно заключить сразу после включения в реестр участников НИС).<br />
                Получить военную ипотеку могут также представители силовых структур, приравненные к военнослужащим: сотрудники Росгвардии, МЧС, ФСБ, ОМОНа, СОБРа, военной прокуратуры, вневедомственной охраны. Если у военного уже есть жилье в собственности, то он все равно имеет право воспользоваться этой программой.<br />
                Специальные предложения для участников СВО узнавайте у наших менеджеров.
                </p>
            </>
        ),
    },
    'IT-ипотека': {
        rate: 6,
        downPayment: 20.1,
        maxLoan: 18000000,
        description: (
            <>
                <p className="plan-calc-info-desc">
                Льготную IT-ипотеку могут получить сотрудники IT-сферы, работающие в зарегистрированных IT-компаниях, получивших аккредитацию Минцифры РФ. Одними из основных условий получения данной ипотеки является наличие у IT-специалиста трудового стажа на текущем месте работы не менее 3-х месяцев и подтверждение дохода (с учётом НДФЛ) <br />
                - от 150 тыс. руб/мес., если компания зарегистрирована в Московской или Ленинградской области, а также в городах РФ с населением более 1 млн человек (кроме Москвы и Санкт-Петербурга) <br />
                - от 90 тыс. руб./мес., если компания зарегистрирована в остальных населенных пунктах РФ.
                </p>
            </>
        ),
    },
    'Базовая ипотека': {
        rate: 20.5,
        downPayment: 10,
        maxLoan: 100000000,
        description: (
            <>
                <p className="plan-calc-info-desc">
                Базовая программа, позволяющая купить новостройку клиентам, которым не подошли льготные программы с господдержкой. <br />
                В рамках программы возможно использование материнского капитала в качестве первоначального взноса или его части. Данная ипотека распространяется на покупку квартиры на этапе строительства, а также её ремонт или другое улучшение. 
                </p>
            </>
        ),
    },
};

const Plan = () => {
    const [activeTab, setActiveTab] = useState<MortgageKey>('Семейная');
    const [loanAmount, setLoanAmount] = useState('3 000 000');
    const [rate, setRate] = useState('8,7%');
    const [downPayment, setDownPayment] = useState<string>('600 000');
    const [term, setTerm] = useState(10); // срок в годах
    const [monthlyPayment, setMonthlyPayment] = useState<string>('53 000');
    const initialLoanAmounts: Record<MortgageKey, number> = {
        'Семейная': 10000000,
        'Военная ипотека': 6000000,
        'IT-ипотека': 10000000,
        'Базовая ипотека': 10000000,
    }

    const formatNumberWithSpaces = (value: number) => {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    };

    const calculateMonthlyPayment = () => {
        const loanAmountValue = parseFloat(loanAmount.replace(/\s/g, '')) || 0;
        const downPaymentValue = parseFloat(downPayment.replace(/\s/g, '')) || 0;
        const rateValue = parseFloat(rate) / 100 / 12; // ежемесячная процентная ставка
        const loanTermMonths = term * 12; // срок в месяцах
        const loanSum = loanAmountValue - downPaymentValue;

        if (loanSum > 0 && rateValue > 0 && loanTermMonths > 0) {
            const monthly = loanSum * (rateValue * Math.pow(1 + rateValue, loanTermMonths)) /
                (Math.pow(1 + rateValue, loanTermMonths) - 1);
            setMonthlyPayment(formatNumberWithSpaces(Math.round(monthly)));
        } else {
            setMonthlyPayment('Ошибка');
        }
    };

    useEffect(() => {
        const data = mortgageData[activeTab];
        setRate(`${data.rate}%`);
        setDownPayment(formatNumberWithSpaces(Math.round((data.downPayment / 100) * initialLoanAmounts[activeTab])));
        setLoanAmount(formatNumberWithSpaces(initialLoanAmounts[activeTab]));
        calculateMonthlyPayment();
    }, [activeTab]);


    useEffect(() => {
        calculateMonthlyPayment();
    }, [loanAmount, downPayment, rate, term]);

    return <section className="plan" id="calculator">
        <div className="container">
            <div className="plan-body">
                <div className="plan-body-text">
                    <h1 className="plan-title title">
                        Ваш идеальный <span>ипотечный план</span>
                    </h1>
                    <div className="plan-calc-info">
                        <div className="plan-calc-info-tab tabs">
                            {Object.keys(mortgageData).map((title) => (
                                <p
                                    key={title}
                                    className={`tab ${activeTab === title ? "is-active" : ""}`}
                                    onClick={() => setActiveTab(title as MortgageKey)}
                                >
                                    {title}
                                </p>
                            ))}
                        </div>
                        <div className="plan-calc-info-text tab_element is-active">
                            {mortgageData[activeTab].description}
                            <div className="plan-calc-info-nums">
                                <p>
                                    <span>от {mortgageData[activeTab].rate}%</span>Ставка
                                </p>
                                <p>
                                    <span>от {mortgageData[activeTab].downPayment}%</span>Первый взнос
                                </p>
                                <p>
                                    <span>до {formatNumberWithSpaces(mortgageData[activeTab].maxLoan)} ₽</span>Сумма
                                    кредита
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="plan-calc">
                    <p className="plan-calc-title">Ипотечный калькулятор</p>
                    <form>
                        <label>
                            <span>Стоимость объекта, руб</span>
                            <input
                                type="text"
                                value={loanAmount}
                                onChange={(e) => setLoanAmount(formatNumberWithSpaces(Number(e.target.value.replace(/\D/g, ''))))}
                            />
                        </label>
                        <label>
                            <span>Процентная ставка, %</span>
                            <input
                                type="text"
                                value={rate}
                                onChange={(e) => setRate(e.target.value)}
                            />
                        </label>
                        <label>
                            <span>Первоначальный взнос, руб</span>
                            <input
                                type="text"
                                value={downPayment}
                                onChange={(e) => setDownPayment(formatNumberWithSpaces(Number(e.target.value.replace(/\D/g, ''))))}
                            />
                        </label>
                        <div className="plan-calc__slider-container">
                            <label>Срок, лет</label>
                            <input
                                type="range"
                                min="0"
                                max="30"
                                step="1"
                                value={term}
                                className="plan-calc__slider"
                                id="yearsRange"
                                onChange={(e) => setTerm(parseInt(e.target.value, 10))}
                            />
                            <div className="plan-calc__slider-labels">
                                {[...Array(7)].map((_, i) => (
                                    <span key={i}>{i * 5}</span>
                                ))}
                            </div>
                        </div>
                        <label className="plan-calc__modile-off">
                            <span>Ежемесячный платеж, руб</span>
                            <input type="text" value={monthlyPayment} readOnly/>
                            <p>В зависимости от выбранного вами банка, процентная ставка может меняться.</p>
                        </label>
                    </form>
                </div>
            </div>
        </div>
    </section>
}

export default Plan